import styled from 'styled-components';
import { Spinner } from '../../../../util/spinner.tsx';
import { EngineeringAdminWrapper } from '../shared.tsx';
import { EngineeringSongList } from './engineering_song_list.tsx';
import { useBrokenCustomMusic, useBrokenSongsForThisSunday, useForceRefreshMusicCaches } from './shared.tsx';
import { UploadButton } from './upload_button.tsx';

export const EngineeringBrokenSongsPage = () => {
  const { brokenSongsByOrg, sundaysPopulated } = useBrokenSongsForThisSunday();
  const { brokenCustomMusicByOrg } = useBrokenCustomMusic();
  useForceRefreshMusicCaches();

  return (
    <EngineeringAdminWrapper title={'Broken Songs'}>
      <OuterWrapper>
        <UploadButton />
        <Heading>This Sunday</Heading>
        <EngineeringSongList hymnsByOrg={brokenSongsByOrg} showSypLink={true} />
        {!sundaysPopulated && <Spinner />}
        <Heading>Custom Music</Heading>
        <EngineeringSongList hymnsByOrg={brokenCustomMusicByOrg} showSypLink={true} />
      </OuterWrapper>
    </EngineeringAdminWrapper>
  );
};

const Heading = styled.h1`
  padding-top: 15px;
`;

const OuterWrapper = styled.div`
  text-align: left;
  padding: 20px 40px;
`;
